<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <div>
            <v-alert
                    v-model="saveAlert"
                    dismissible
                    type="success">
                User profile updated.
            </v-alert>
            <v-progress-linear v-if="waiting" :indeterminate="true"/>
            <v-container>
                <v-row align="center" justify="center">
                    <v-col xs="12" sm="6" md="4">
                        <v-card>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                            </v-card-actions>
                            <v-card-text>
                                <ValidationProvider
                                        mode="aggressive"
                                        rules="requiredName|minName:3"
                                        :debounce="300"
                                        v-slot="{ errors }">
                                    <v-text-field
                                            v-model.trim="currentUser.displayName"
                                            label="Name"
                                            solo
                                            :error-messages=errors[0]>
                                    </v-text-field>
                                </ValidationProvider>
                                <ValidationProvider
                                        mode="aggressive"
                                        rules="requiredEmail|email"
                                        :debounce="300"
                                        v-slot="{ errors }">
                                    <v-text-field
                                            v-model.trim="currentUser.emailAddress"
                                            label="Email Address"
                                            solo
                                            :error-messages=errors[0]>
                                    </v-text-field>
                                </ValidationProvider>
                                <div>
                                    <label class="checkbox">
                                    <ValidationProvider
                                            rules="requiredAgree"
                                            v-slot="{ errors }">
                                        <input type="checkbox" v-model="currentUser.healthCareProfessional">
                                        <span class="black--text pl-1">I agree that either I am a certified healthcare professional in the United States of America, otherwise Reflex data is for investigational and research purposes only, and should not be used for medical evaluation.</span>
                                        <br/><span class="terms">{{ errors[0]}}</span>
                                    </ValidationProvider>
                                    </label>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </ValidationObserver>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
    import { email, required, min } from 'vee-validate/dist/rules';

    extend('requiredName',
    {
        ...required,
        message: 'A name is required.'
    });
    extend('minName',
    {
        ...min,
        message: 'A name is required and must be at least 3 characters.'
    });
    extend('requiredEmail',
    {
        ...required,
        message: 'A valid email address is required.'
    });
    extend('email',
    {
        ...email,
        message: 'A valid email address is required.'
    });
    extend('requiredAgree',
    {
        validate: value =>
        {
            return value
        },
        message: 'You must agree.'
    });

    export default
    {
        name: 'user-profile-tab',
        components:
        {
            ValidationProvider,
            ValidationObserver
        },
        data: function ()
        {
            return {
                saveAlert: false
            }
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser ? state.currentUser : {}
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        methods:
        {
            ...mapActions('auth', ['UPDATE_CURRENT_USER']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            async save()
            {
                if (await this.$refs.observer.validate())
                {
                    try
                    {
                        this.currentUser.healthCareProfessional = true;
                        this.HIDE_SNACKBAR();
                        this.WAITING(true);
                        await this.UPDATE_CURRENT_USER(this.currentUser);
                        this.saveAlert = true;
                        setTimeout(() =>
                        {
                            this.saveAlert = false;
                        }, 2000)
                    }
                    catch (error)
                    {
                        this.SHOW_SNACKBAR_ERROR(error.message)
                    }
                    this.WAITING(false)
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .terms
    {
        color: red;
    }
</style>